export default {
  loaderSvg: 'loader-svg',
  loaderBox: 'loader-box',
};
